import { constants as config } from '@config';
import Store from '@store';
import { saveMetadata } from 'src/store/actions/metadata.action';
import { saveTableOfContentsPages } from './utils';
import TableOfContentsGenerator from './table-of-contents-generator';

module.exports = Backbone.View.extend({
  events: {
    'click .tab-settings .selected-table-format': 'toggleDropDownList',
    'click .tab-settings .selected-leader-style': 'toggleDropDownList',
    'click .desygner-dropdown-select-item[data-table-format]': 'selectTableFormat',
    'click .desygner-dropdown-select-item[data-leader-style]': 'selectLeaderStyle',
    'change .input-container input[name="table-levels"]': 'selectLevel',
    'click .input-container span.up-arrow': 'increaseLevel',
    'click .input-container span.down-arrow': 'decreaseLevel',
    'click .desygner-custom-check label[name="isPageNumber"]': 'selectCheckBox',
    'click .desygner-custom-check label[name="isAlignedRight"]': 'selectCheckBox',
    'click .desygner-custom-check label[name="isLinkUsed"]': 'selectCheckBox',
    'click .table-btn-container .action[data-action="table-cancel"]': 'closeModal',
    'click .table-btn-container .action[data-action="table-save"]': 'saveModal'
  },

  initialize: function () {
    _.bindAll(this, 'show');
    this._canvasLeftMargin = config.tableOfContents.canvasLeftMargin;
    this.tableFormat = config.tableOfContents.tableFormat;
    this.leaderStyle = config.tableOfContents.leaderStyle;
    this.levels = config.tableOfContents.levels;
    this.isPageNumber = config.tableOfContents.isPageNumber;
    this.isAlignedRight = config.tableOfContents.isAlignedRight;
    this.isLinkUsed = config.tableOfContents.isLinkUsed;
    this.isMetadataExisted = config.tableOfContents.isMetadataExisted;
  },

  show: function (setting) {
    this.updateModalSetting(setting);
    this.updateLeaderStyleSetting();
    this.hideDropDownList();
    this.drawModal();
    this.previewTableOfContents();
  },

  updateModalSetting: function (setting) {
    if (!setting) return;

    this.tableFormat = setting.format ?? this.tableFormat;
    this.leaderStyle = setting.leader;
    this.levels = Math.min(setting.levels, config.tableOfContents.levels);
    this.isPageNumber = setting.page_numbers;
    this.isAlignedRight = setting.align_page_numbers_right;
    this.isLinkUsed = setting.use_links;
    this.isMetadataExisted = true;
  },

  updateLeaderStyleSetting: function () {
    this.leaderStyle = this.isPageNumber && this.isAlignedRight ? this.leaderStyle : 'none';
  },

  drawModal: function () {
    this.drawTableFormatDropdown();
    this.drawLeaderStyleDropdown();
    this.drawInputLevels();
    this.drawCheckBox();

    this.$el.css('left', this._canvasLeftMargin);
    this.$el.fadeToggle('fast');
  },

  drawCheckBox: function () {
    const checkBoxContainer = this.el.querySelector('.checkbox-container');
    checkBoxContainer.querySelector('input[name="isPageNumber"]').checked = this.isPageNumber;
    checkBoxContainer.querySelector('input[name="isAlignedRight"]').checked = this.isAlignedRight;
    checkBoxContainer.querySelector('input[name="isLinkUsed"]').checked = this.isLinkUsed;
    this.toggleDisableIsAlignRight();
    this.toggleDisableIsLinkUsed();
    this.toggleDisableLeaderStyle();
  },

  drawInputLevels: function () {
    const inputContainer = this.el.querySelector('.input-container');
    const inputLevels = inputContainer.querySelector('input');
    inputLevels.value = this.levels;
  },

  drawLeaderStyleDropdown: function () {
    this.removeActiveDropdownItems('.dropdown-container.leader-style');
    const leaderStyleContainer = this.el.querySelector('.dropdown-container.leader-style');
    const selectedLeaderStyle = leaderStyleContainer.querySelector('.selected-leader-style');
    selectedLeaderStyle.dataset.leaderStyle = this.leaderStyle;
    selectedLeaderStyle.querySelector('span').textContent = INKIVE.TranslateHelper.translate(`top_submenu.table_of_contents_modal.leader_style.${this.leaderStyle}`);
    leaderStyleContainer.querySelector(`.desygner-dropdown-select-item[data-leader-style="${this.leaderStyle}"]`).classList.add('select-active');
  },

  drawTableFormatDropdown: function () {
    this.removeActiveDropdownItems('.dropdown-container.table-format');
    const tableFormatContainer = this.el.querySelector('.dropdown-container.table-format');
    const selectedTableFormat = tableFormatContainer.querySelector('.selected-table-format');
    selectedTableFormat.dataset.tableFormat = this.tableFormat;
    selectedTableFormat.querySelector('span').textContent = INKIVE.TranslateHelper.translate(`top_submenu.table_of_contents_modal.table_format.${this.tableFormat}`);
    tableFormatContainer.querySelector(`.desygner-dropdown-select-item[data-table-format="${this.tableFormat}"]`).classList.add('select-active');
  },

  removeActiveDropdownItems: function (query) {
    const dropdownContainer = this.el.querySelector(query);
    const dropdownItems = [...dropdownContainer.querySelectorAll('.desygner-dropdown-select-item')];
    dropdownItems.forEach(item => item.classList.remove('select-active'));
  },

  toggleDisableLeaderStyle: function () {
    const leaderStyleContainer = this.el.querySelector('.dropdown-container.leader-style');
    leaderStyleContainer.classList.remove('disabled');
    if (!this.isPageNumber || !this.isAlignedRight) leaderStyleContainer.classList.add('disabled');
  },

  toggleDisableIsAlignRight: function () {
    const li = this.el.querySelector('label[name="isAlignedRight"]').closest('li');
    li.classList.remove('disabled');
    if (!this.isPageNumber) li.classList.add('disabled');
  },

  toggleDisableIsLinkUsed: function () {
    const li = this.el.querySelector('label[name="isLinkUsed"]').closest('li');
    li.classList.remove('disabled');
    if (!this.isPageNumber) li.classList.add('disabled');
  },

  toggleDropDownList: function (event) {
    const dropDownMenu = event.currentTarget;
    const container = dropDownMenu.closest('.dropdown-container');
    if (container.classList.contains('disabled')) return;

    const subMenu = container.querySelector('.desygner-dropdown-select');
    const subMenus = dropDownMenu.closest('div[data-id="table-of-contents"]').querySelectorAll('.desygner-dropdown-select.visible');

    if (subMenu.classList.contains('visible')) {
      subMenu.classList.remove('visible');
    } else {
      [...subMenus].forEach(element => {
        element.classList.remove('visible');
      });
      subMenu.classList.toggle('visible');
    }
  },

  hideDropDownList: function () {
    const subMenus = [...this.el.querySelectorAll('.desygner-dropdown-select.visible')];
    subMenus.forEach(element => {
      element.classList.remove('visible');
    });
  },

  selectTableFormat: function (event) {
    if (!event || !event.currentTarget) return;

    const { currentTarget: li } = event;
    const { parentElement: ul } = li;
    const { tableFormat } = li.dataset;

    this.tableFormat = tableFormat ?? this.tableFormat;

    ul.querySelectorAll('li').forEach(element => element.classList.remove('select-active'));
    ul.parentElement.querySelector('.desygner-dropdown-selected span').textContent = li.textContent;
    ul.parentElement.querySelector('.desygner-dropdown-selected').dataset.tableFormat = tableFormat;

    ul.classList.toggle('visible');
    li.classList.add('select-active');

    this.setStyleFromTableFormat();

    this.drawCheckBox();
    this.drawLeaderStyleDropdown();
    this.previewTableOfContents();
  },

  setStyleFromTableFormat () {
    if (this.tableFormat === 'simple') {
      this.isAlignedRight = false;
      this.isPageNumber = true;
      this.isLinkUsed = true;
      this.leaderStyle = 'none';
    } else if (this.tableFormat === 'classic') {
      this.isAlignedRight = true;
      this.isPageNumber = true;
      this.isLinkUsed = true;
      this.leaderStyle = 'none';
    } else if (this.tableFormat === 'formal') {
      this.isAlignedRight = true;
      this.isPageNumber = true;
      this.isLinkUsed = true;
      this.leaderStyle = 'dots';
    }
  },

  selectLeaderStyle: function (event) {
    if (!event || !event.currentTarget) return;

    const { currentTarget: li } = event;
    const { parentElement: ul } = li;
    const { leaderStyle } = li.dataset;

    this.leaderStyle = leaderStyle;

    ul.querySelectorAll('li').forEach(element => element.classList.remove('select-active'));
    ul.parentElement.querySelector('.desygner-dropdown-selected span').textContent = li.textContent;
    ul.parentElement.querySelector('.desygner-dropdown-selected').dataset.leaderStyle = leaderStyle;
    ul.classList.toggle('visible');
    li.classList.add('select-active');
    this.previewTableOfContents();
  },

  selectCheckBox: function (event) {
    const checkBox = event && event.currentTarget && event.currentTarget.querySelector('input');
    if (!checkBox) return;

    this[checkBox.name] = checkBox.checked;

    if (!this.isPageNumber) {
      this.isAlignedRight = false;
      this.isLinkUsed = false;
    }

    this.updateLeaderStyleSetting();
    this.drawCheckBox();
    this.drawLeaderStyleDropdown();
    this.previewTableOfContents();
  },

  selectLevel: function (event) {
    const input = event && event.currentTarget;
    if (!input) return;

    input.value = input.max
      ? Math.min(parseInt(input.max), parseInt(input.value) || 0)
      : parseInt(input.value);
    input.value = input.min
      ? Math.max(parseInt(input.min), parseInt(input.value) || 0)
      : parseInt(input.value);

    this.levels = input.value;
    this.previewTableOfContents();
  },

  increaseLevel: function (event) {
    const button = event && event.currentTarget;
    if (!button) return;

    const input = this.el.querySelector('.input-container input[name="table-levels"]');
    input.stepUp();
    this.levels = input.value;
    this.previewTableOfContents();
  },

  decreaseLevel: function (event) {
    const button = event && event.currentTarget;
    if (!button) return;

    const input = this.el.querySelector('.input-container input[name="table-levels"]');
    input.stepDown();
    this.levels = input.value;
    this.previewTableOfContents();
  },

  closeModal: function () {
    this.el.style.display = 'none';
  },

  saveModal: async function () {
    const tableOfContentsMetadata = Store.getState().metadata?.table_of_contents;

    INKIVE.Modal.togglePageLoader(true);

    // Backward compatibility, convert array of page ID to array of object
    const pages = tableOfContentsMetadata?.pages || [];
    if (pages.length && !pages[0].id) {
      tableOfContentsMetadata.pages = pages.map(page => ({ id: page }));
    }

    const modalData = {
      ...tableOfContentsMetadata,
      format: this.tableFormat,
      leader: this.leaderStyle,
      levels: this.levels,
      page_numbers: this.isPageNumber,
      align_page_numbers_right: this.isAlignedRight,
      use_links: this.isLinkUsed,
      pages: pages || []
    };

    await Store.dispatch(saveMetadata({ table_of_contents: modalData }));

    const settings = (({ tableFormat, leaderStyle, levels, isPageNumber, isAlignedRight, isLinkUsed }) => (
      { tableFormat, leaderStyle, levels, isPageNumber, isAlignedRight, isLinkUsed }
    ))(this);

    await INKIVE.EditorFacade.handle('page', 'save');

    const headingsSummary = await INKIVE.TableOfContentsFactory.fetchHeadings();
    const existedTableOfContentsPages = await INKIVE.TableOfContentsFactory.fetchTableOfContentsPages();
    await INKIVE.TableOfContentsFactory.fetchTableOfContentsFonts(headingsSummary);
    const size = INKIVE.TableOfContentsFactory.calculateTableOfContentsSize(existedTableOfContentsPages);
    const positions = pages.map(page => page.position);
    const pageNumberOffset = new TableOfContentsGenerator().initialize(settings, headingsSummary, size, existedTableOfContentsPages, positions).getNumberOfPages();
    const tableOfContentsGenerator = new TableOfContentsGenerator().initialize(settings, headingsSummary, size, existedTableOfContentsPages, positions);
    const tableOfContentsPages = tableOfContentsGenerator.drawTableOfContents(pageNumberOffset);

    saveTableOfContentsPages(tableOfContentsPages);
    this.closeModal();
  },

  previewTableOfContents: function () {
    this.el.querySelector('.tab-preview').innerHTML = null;
    const previewContainer = document.createElement('div');
    previewContainer.className = 'preview-container';

    for (let i = 0; i < Math.min(this.levels, config.tableOfContents.levels); i++) {
      const section = document.createElement('section');
      section.className = `heading heading-${i + 1}`;

      const title = this.createTitleSpan(i);
      const leader = this.createLeaderSpan(i);
      const pageNumber = this.createPageNumberSpan(i);

      title && section.appendChild(title);
      leader && section.appendChild(leader);
      pageNumber && section.appendChild(pageNumber);

      previewContainer.appendChild(section);
    }

    this.el.querySelector('.tab-preview').appendChild(previewContainer);
  },

  createTitleSpan: function (index) {
    const title = document.createElement('span');
    title.className = 'title';
    title.textContent = `Heading ${index + 1}`;

    if (this.tableFormat !== 'classic' || index !== 0) return title;
    title.style.letterSpacing = '0px';
    return title;
  },

  createLeaderSpan: function () {
    if (!this.isPageNumber || !this.isAlignedRight) return null;

    const styles = {
      dots: '.............................',
      line: '_____________________________',
      dashes: '_ _ _ _ _ _ _ _ _ _ _ _ _ _',
      none: '                             '
    };
    const leader = document.createElement('span');
    leader.className = 'leaders ' + this.leaderStyle;
    leader.textContent = styles[this.leaderStyle];

    return leader;
  },

  createPageNumberSpan: function (index) {
    if (!this.isPageNumber) return null;
    const pageNumber = document.createElement('span');
    pageNumber.className = 'page';
    pageNumber.textContent = index + 1;

    return pageNumber;
  },

  sanitizeString: function (string) {
    if (!string) return 'None';
    const spittedWord = string.replace('-', ' ');
    return spittedWord.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
  }
});
